var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20Z",
    fill: "url(#paint0_radial_391_559)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2195 14.4165C16.9643 10.75 23.0358 10.75 26.7805 14.4165L27.2312 14.8577C27.4185 15.041 27.4185 15.3383 27.2312 15.5216L25.6895 17.0311C25.5959 17.1227 25.4441 17.1227 25.3505 17.0311L24.7303 16.4238C22.1178 13.866 17.8822 13.866 15.2698 16.4238L14.6056 17.0741C14.512 17.1658 14.3602 17.1658 14.2666 17.0741L12.7249 15.5646C12.5376 15.3813 12.5376 15.0841 12.7249 14.9008L13.2195 14.4165ZM29.969 17.5382L31.3411 18.8816C31.5283 19.065 31.5283 19.3622 31.3411 19.5455L25.1541 25.6032C24.9668 25.7865 24.6633 25.7865 24.476 25.6032C24.476 25.6032 24.476 25.6032 24.476 25.6032L20.0848 21.3039C20.038 21.2581 19.9621 21.2581 19.9153 21.3039C19.9153 21.3039 19.9153 21.3039 19.9153 21.3039L15.5242 25.6032C15.337 25.7865 15.0334 25.7865 14.8462 25.6032C14.8462 25.6032 14.8462 25.6032 14.8462 25.6032L8.65898 19.5454C8.47175 19.3621 8.47175 19.0649 8.65898 18.8816L10.0311 17.5381C10.2184 17.3548 10.5219 17.3548 10.7092 17.5381L15.1004 21.8375C15.1472 21.8834 15.2231 21.8834 15.2699 21.8375C15.2699 21.8375 15.2699 21.8375 15.2699 21.8375L19.6609 17.5381C19.8482 17.3548 20.1517 17.3548 20.339 17.5381C20.339 17.5381 20.339 17.5381 20.339 17.5381L24.7302 21.8375C24.777 21.8833 24.8529 21.8833 24.8997 21.8375L29.2909 17.5382C29.4781 17.3549 29.7817 17.3549 29.969 17.5382Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_391_559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 20) scale(40)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/walletConnect.d9e37e226c3eac1931e56d17789ebff3.svg";
export { ForwardRef as ReactComponent };